import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetCreatedFlagsRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetCreatedFlagsResponseDtoSchema = z.object({
  changePct: z.number().nullable(),
  count: z.number(),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
});

export type GetCreatedFlagsRequestDto = z.infer<
  typeof _GetCreatedFlagsRequestDtoSchema
>;
export type GetCreatedFlagsResponseDto = z.infer<
  typeof GetCreatedFlagsResponseDtoSchema
>;

export const getCreatedFlagsKpi = (
  params: GetCreatedFlagsRequestDto,
  config?: AxiosRequestConfig<GetCreatedFlagsRequestDto>
) =>
  api
    .get('alerts/dashboard/created-flags', { params, ...config })
    .then(responseContract(GetCreatedFlagsResponseDtoSchema));
